import React from 'react';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import ResetBtn from './components/ResetBtn';
import style from './ChangePositionControlPanel.module.scss';

const ChangePositionControlPanel: React.FC = () => {
	return (
		<div className={style.container} data-test="ChangePositionControlPanel">
			<div className={style.selectWrapper}>
				<CustomerSelect />
				<RestaurantSelect />
			</div>
			<ResetBtn />
		</div>
	);
};

export default ChangePositionControlPanel;
